import { useQuery } from '@tanstack/react-query'
import { api } from './api.ts'

/**
 * Permissoes do controle de acesso resolvidas no SERVIDOR
 * (SPEC-20260814-1444) — mesmo padrao do bundle de toggles.
 *
 * Fail-open enquanto carrega: esconder botoes/menus e cosmetico; quem protege
 * e o `requirePermission` na API. Depois de carregado, chave ausente = nega.
 */
export function usePermissionBundle() {
  return useQuery({
    queryKey: ['access-control-bundle'],
    queryFn: async () => (await api['access-control'].bundle.$get()).json(),
    staleTime: 60 * 1000,
  })
}

/** O usuario logado pode `key`? (`work-items.item.create`...) */
export function usePermission(key: string): boolean {
  const bundle = usePermissionBundle()
  if (bundle.data === undefined) return true
  return bundle.data.permissions?.[key] ?? false
}
